import { ICellData } from "Interfaces/ICellData";
import { IParser } from "Interfaces/IParser";
import { ITableRow } from "Interfaces/ITableRow";
import moment from "moment";

const dateNowObj = moment(moment().format("YYYY-MM-DD"), "YYYY-MM-DD");

export default class BannerStudent implements 
		IParser<BannerStudent>, 
		ITableRow {
	public name:string;
	public tldr:string;
	public start:string;
	public eta:number;
	public mustPullIf:string;
	public easySkipIf:string;
	public useCases:string;
	public whatDo:string;
	public investments:string;
	public rants:string;
	public comments:string;
	public farmable:string;
	public updated:string;
	public duration:string;

	getHeaders() {
		return [
			"name",
			"tldr",
			"start",
			"eta",
			"mustPullIf",
			"easySkipIf",
			"useCases",
			"whatDo",
			"investments",
			"rants",
			"comments",
			"farmable",
			"updated",
		];
	}

	getEta() {
		const raw = Math.abs(this.eta);
		return raw + " day" + (raw>1 ? 's' : '') + (this.eta < 0 ? " ago. Lasted "+this.duration+" days" : ". Lasts "+this.duration+" days");
	}
	toArray() {
		return [
			this.name,
			this.tldr,
			this.start,
			this.eta.toString(),
			this.mustPullIf,
			this.easySkipIf,
			this.useCases,
			this.whatDo,
			this.investments,
			this.rants,
			this.comments,
			this.farmable,
			this.updated,
		];
	}
	toKeyValues() {
		return {
			name: this.name,
			tldr: this.tldr,
			start: this.start,
			eta: this.eta.toString(),
			mustPullIf: this.mustPullIf,
			easySkipIf: this.easySkipIf,
			useCases: this.useCases,
			whatDo: this.whatDo,
			investments: this.investments,
			rants: this.rants,
			comments: this.comments,
			farmable: this.farmable,
			updated: this.updated,
		};
	}
	
	parse(data:ICellData[]): BannerStudent {
		try {
			return BannerStudent.parse(data);
		} catch {
			return null;
		}
	}

	static parse(data:ICellData[]): BannerStudent {
		let student = new BannerStudent();
		if (!!!data[1]?.v) return null;
		let i=1;
		student.name = data[i++]?.v ?? '';
		student.start = data[i++]?.f ?? '';
		student.duration = data[i++]?.v ?? '';
		i++; // ETA
		student.eta = BannerStudent.parseEta(data);
		student.tldr = data[i++]?.v ?? '';
		student.mustPullIf = data[i++]?.v ?? '';
		student.easySkipIf = data[i++]?.v ?? '';
		student.useCases = data[i++]?.v ?? '';
		student.whatDo = data[i++]?.v ?? '';
		student.investments = data[i++]?.v ?? '';
		student.rants = data[i++]?.v ?? '';
		student.comments = data[i++]?.v ?? '';
		student.farmable = data[i++]?.v ?? '';
		student.updated = data[i++]?.f ?? '';

		return student;
	}
	
	static parseEta(data:ICellData[]): number {
		const i = 2
		const eta = moment(data[i]?.f ?? '', "YYYY-MMM-DD").diff(dateNowObj, "days");
		if (Number.isNaN(eta))
			return moment(data[i]?.f ?? '', "YYYY-MM-DD").diff(dateNowObj, "days")
		return eta
	}
}